// src/com/arrival_to_store/ArrivalToStoreLine.js
import React, { useState, useEffect, useRef } from 'react';
import { styled  } from '@mui/material/styles';
import { Box } from '@mui/system';
import { AppStyle } from '../../value/AppConst';
import { SorterLabel } from '../../common/SorterLabel';

const LineBox = styled(Box)({
    borderBottom: AppStyle.BorderCCC, boxSizing: 'border-box',
    minHeight: 34,
    display: 'flex', alignItems: 'center',
});

const DcName = styled(Box)({ width: '22%'});
const StoreName = styled(Box)({ width: '28%'});
const Hocha = styled(Box)({ width: '4rem', textAlign: 'center' });
const VehPlates = styled(Box)({ flexGrow: 1});


/**
 * 점포관리 (출발지, 도착지, 호차, 차량번호) 출력. (한 줄)
 */
export default function ArrivalToStoreLine({
    item,
    index,
    itemSelected,
    onClick,
    onClickSorter, // (id, sortState) => void
    idSorted, // id of the column that is currently sorted
}) {
    const [isVisible, setIsVisible] = useState(false);
    const itemRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                // Update state when intersection status changes
                setIsVisible(entry.isIntersecting);
            },
            {
                root: null, // viewport
                rootMargin: '0px',
                threshold: 0.1, // trigger when 10% of the element is visible
            }
        );

        const currentRef = itemRef.current;
        if (currentRef) {
            observer.observe(currentRef);
        }

        // Cleanup observer on component unmount
        return () => {
            if (currentRef) {
                observer.unobserve(currentRef);
            }
        };
    }, []);

    const renderLine = () => {
        return(
            <>
            <DcName>{item.dcName}</DcName>
            <StoreName>{item.storeName}</StoreName>
            <Hocha>{item.hocha}</Hocha>
            <VehPlates>{item.vehPlates}</VehPlates>
            </>
        );
    };

    if(!item) {
        return(
            <Box
                style={{
                    display: 'flex', alignItems: 'center',
                    backgroundColor: AppStyle.PrimaryRGB, color: 'white',
                    textAlign: 'center', padding: '0.5rem 0',
                }}
            >
                <DcName>출발지</DcName>
                <StoreName>
                    <SorterLabel
                        id="storeName"
                        label="도착지"
                        onClick={onClickSorter}
                        idSorted={idSorted}
                    />
                </StoreName>
                <Hocha>호차</Hocha>
                <VehPlates>
                    <SorterLabel
                        id="vehPlates"
                        label="차량"
                        onClick={onClickSorter}
                        idSorted={idSorted}
                    />
                </VehPlates>
            </Box>
        );
    }

    return(
        <LineBox
            ref={itemRef}
            onClick={() => {
                onClick(item, index);
            }}
            style={{
                backgroundColor: item.planId === (itemSelected || {}).planId ? '#e0f7fa' : index % 2 === 0 ? '#ffffff' : '#f9f9f9',
            }}
        >
            {isVisible ? renderLine() : null}
        </LineBox>
    );
}